// app/src/app/layouts/BackgroundLayout.jsx
import React from 'react';

const BackgroundLayout = ({ children, backgroundImage = '/images/background.png' }) => {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: 'var(--retro-bg-dark)',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* 1. Base tiled background (fill.png) */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: "url('/images/fill.png')",
          backgroundRepeat: 'repeat',
          zIndex: 0
        }}
      />

      {/* 2. Hero background image (large) */}
      <div 
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          opacity: 0.4,
          zIndex: 1
        }}
      />

      {/* 3. Scanlines / Overlay Effect */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(rgba(18, 16, 16, 0) 50%, rgba(0, 0, 0, 0.25) 50%), linear-gradient(90deg, rgba(255, 0, 0, 0.06), rgba(0, 255, 0, 0.02), rgba(0, 0, 255, 0.06))',
          backgroundSize: '100% 4px, 3px 100%',
          zIndex: 2,
          pointerEvents: 'none'
        }}
      />

      {/* 4. Dark Overlay */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'var(--retro-bg-overlay)',
          zIndex: 3,
          pointerEvents: 'none'
        }}
      />

      {/* Content */}
      <div style={{ position: 'relative', zIndex: 4, flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
    </div>
  );
};

export default BackgroundLayout;
